import {
  useQuery, UseQueryResult, useQueryClient, useMutation,
} from '@tanstack/react-query';
import { getVehicleDetailsLocations, getVehicleDetailsLocationsByIds } from '../../services/MapsService';
import { LocationDetailsResponse } from '../../types/Maps';

function useGetVehicleLocations(
  fleetId: string,
  query: string,
  id: string,
  refetch = true,
): UseQueryResult<LocationDetailsResponse> {
  return useQuery(
    ['vehicleLocations', fleetId, id, query],
    async (): Promise<LocationDetailsResponse> => getVehicleDetailsLocations(fleetId, id, query),
    {
      retry: 1,
      retryDelay: 3000,
      refetchInterval: refetch ? 5000 : false,
      keepPreviousData: true,
      enabled: !!id,
    },
  );
}

export function useGetVehicleLocationsByIds(
  successCb: (args: LocationDetailsResponse[]) => void,
  failureCb: (error: string) => void,
): LocationDetailsResponse {
  const queryClient = useQueryClient();

  return useMutation(getVehicleDetailsLocationsByIds, {
    onSuccess: (data) => {
      successCb(data);
      queryClient.invalidateQueries({ queryKey: ['vehicleLocationsByIds'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default useGetVehicleLocations;
